import type { Ref } from 'vue';

import type { FeatureToggleName } from '../customFeatureToggles';

export const statsigFeatureMap: Partial<
  Record<FeatureToggleName, Ref<boolean>>
> = {};
